import { render } from "./Wraps.vue?vue&type=template&id=33123531&scoped=true"
import script from "./Wraps.vue?vue&type=script&lang=js"
export * from "./Wraps.vue?vue&type=script&lang=js"

import "./Wraps.vue?vue&type=style&index=0&id=33123531&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33123531"]])

export default __exports__